module.exports = __webpack_public_path__ + "img/onboarding/share-video-711519eadfd818ebba5abac670a62b8b.svg";